"use client";
import { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";
import SVG from "react-inlinesvg";

import Menu from "@/components/common/Menu"

export default function Header() {
  const pathname = usePathname();
  const [isMenuOpen, set_isMenuOpen] = useState(false);
  const [pullDown_1, set_pullDown_1] = useState(false);
  const [pullDown_2, set_pullDown_2] = useState(false);
  const directionTimer = useRef(null);
  // const beforeFocusedElement = useRef(null);

  const [direction, setDirection] = useState<'up' | 'down'>()
  let beforeScrollPosition = 0,
      nowScrollPosition = 0

  const menuOpen = () => {
    clearTimeout(directionTimer.current)
    document.body.classList.add("lock");
    set_isMenuOpen(true)
    document.body.classList.add("menu-open")
    // beforeFocusedElement.current = document.activeElement;
  }
  const menuClose = () => {
    document.body.classList.remove("lock");
    set_isMenuOpen(false)
    document.body.classList.remove("menu-open")
    document.body.classList.remove("scroll-down")
  }

  // スクロール方向を検知する処理
  const handleScroll = () => {
    nowScrollPosition = document.documentElement.scrollTop

    if (beforeScrollPosition === nowScrollPosition) return
    if(nowScrollPosition <= 0) {
      setDirection('up')
    }
    else if (beforeScrollPosition < nowScrollPosition) {
      setDirection('down')
    } else {
      setDirection('up')
    }
    beforeScrollPosition = nowScrollPosition
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if(direction=="down") {
      document.body.classList.add("scroll-down")
    } else {
      document.body.classList.remove("scroll-down")
    }
  }, [direction])

  useEffect(() => {
    set_pullDown_1(false)
    set_pullDown_2(false)
    menuClose()
  }, [pathname]);

  return (
    <header className="header">
      <div className="header-inner sizeContainer">
        <div className="header-logo en spOnly">
          <h1>©BG inc.</h1>
        </div>
        <div className="header-nav-list pcOnly">
          <Link className="nav-item scaleHover en" href="/">
            <div className="title">Home</div>
          </Link>
          <Link className="nav-item scaleHover en" href="/vegetables/">
            <div className="title">Vegetables</div>
          </Link>
          <div className={`nav-item ${pullDown_1?"active":""}`} 
            onMouseEnter={() => set_pullDown_1(true)}
            onClick={() => set_pullDown_1(true)}
            onMouseLeave={() => set_pullDown_1(false)}
          >
            <div className="scaleHover">
              <button className="inner" type="button">
                <span className="title en" >Method</span>
                <i className="icon icon-menu-down">
                  <SVG src="/assets/img/common/icon/icon-menu-down.svg" />
                </i>
              </button>
            </div>
            <div className="nav-group hover-item">
              <Link className="nav-item scaleHover" href="/method/">
                <div className="inner">
                  <div className="title en">Method トップ</div>
                  <i className="icon icon-link"><SVG src="/assets/img/common/icon/icon-menu-right.svg" /></i>
                </div>
              </Link>
              <Link className="nav-item scaleHover" href="/method/soil-solution/">
                <div className="inner">
                  <div className="title en">Soil Solution</div>
                  <i className="icon icon-link"><SVG src="/assets/img/common/icon/icon-menu-right.svg" /></i>
                </div>
              </Link>
              <Link className="nav-item scaleHover" href="/method/agrilca/">
                <div className="inner">
                  <div className="title en">Agri LCA+</div>
                  <i className="icon icon-link"><SVG src="/assets/img/common/icon/icon-menu-right.svg" /></i>
                </div>
              </Link>
              <Link className="nav-item scaleHover" href="/method/next-green-credit/">
                <div className="inner">
                  <div className="title en">Next Green Credit</div>
                  <i className="icon icon-link"><SVG src="/assets/img/common/icon/icon-menu-right.svg" /></i>
                </div>
              </Link>
            </div>
          </div>
          <Link className="nav-item scaleHover" href="/10rules/">
            <div className="title en">10 Rules</div>
          </Link>
          <div className={`nav-item ${pullDown_2?"active":""}`} 
            onMouseEnter={() => set_pullDown_2(true)}
            onClick={() => set_pullDown_2(true)}
            onMouseLeave={() => set_pullDown_2(false)}
          >
            <div className="scaleHover">
              <button className="inner" type="button">
                <span className="title en" >How to Join</span>
                <i className="icon icon-menu-down">
                  <SVG src="/assets/img/common/icon/icon-menu-down.svg" />
                </i>
              </button>
            </div>
            <div className="nav-group hover-item">
              <Link className="nav-item scaleHover" href="/for-farmers/">
                <div className="inner">
                  <div className="title en">For Farmers </div>
                  <i className="icon icon-link"><SVG src="/assets/img/common/icon/icon-menu-right.svg" /></i>
                </div>
              </Link>
              <Link className="nav-item scaleHover" href="/for-companies/">
                <div className="inner">
                  <div className="title en">For Companies</div>
                  <i className="icon icon-link"><SVG src="/assets/img/common/icon/icon-menu-right.svg" /></i>
                </div>
              </Link>
              <Link className="nav-item scaleHover" href="/for-everyone/">
                <div className="inner">
                  <div className="title en">For Everyone</div>
                  <i className="icon icon-link"><SVG src="/assets/img/common/icon/icon-menu-right.svg" /></i>
                </div>
              </Link>
            </div>
          </div>
          <Link className="nav-item scaleHover" href="/about/">
            <div className="title en">About Us</div>
          </Link>
        </div>
        <button className="button-menu scaleHover" type="button" aria-label={isMenuOpen ? "Close menu" : "Open menu"} onClick={()=>{
          if(isMenuOpen){
            menuClose()
          } else {
            menuOpen()
          }
        }}>
          <div className="inner">
            <span className="n1"></span>
            <span className="n2"></span>
          </div>
        </button>

        {isMenuOpen && (
          <div className="modal modal-menu" role="dialog" aria-modal="true" aria-label="Main menu">
            <div className="overlay" onClick={()=>{
              menuClose()
            }}>
            </div>
            <div className="modal-inner">
              <Menu isGreen={true}/>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
